import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=a895ae32&scoped=true"
import script from "./LanguagePicker.vue?vue&type=script&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&lang=js"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=a895ae32&prod&lang=scss&scoped=true"
import style1 from "./LanguagePicker.vue?vue&type=style&index=1&id=a895ae32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a895ae32",
  null
  
)

export default component.exports